module.exports = __webpack_public_path__ + "assets/img/contentBj4.24354126.png";